import PhoneInput from "react-phone-number-input";
import { FieldMetaData } from "../../../types/SchemaFactory";
import languageServiceFactory from "../../../services/LanguageServiceImpl";
import "react-phone-number-input/style.css";
import { useTranslation } from "react-i18next";
import CustomError from "../../../custom-components/form-inputs/CustomError";

interface PhoneInputProps<T> {
    meta: FieldMetaData;
    field: keyof T;
    value: string;
    errorKey: string;
    onChange: (value: string) => void;
    className?: string;
}

const languageService = languageServiceFactory();

function PhoneInputComponent<T>(props: PhoneInputProps<T>) {
    const { t } = useTranslation();
    return (
        <div>
            {props.meta.placeholderKey && (
                <label className="block mb-2 text-lg font-semibold text-[#344054]" htmlFor={props.meta.placeholderKey}>
                    {t(props.meta.placeholderKey)}
                </label>
            )}
            <PhoneInput
                className={`px-3 py-2 text-base text-[#344054] bg-white border-2 border-[#d0d5dd] shadow-sm rounded-lg placeholder-[#667085] ${props.className}`}
                tabIndex="phone"
                placeholder={t(props.meta.placeholderKey)}
                name={props.field}
                value={props.value}
                onChange={props.onChange}
                international={true}
                limitMaxLength={true}
                labels={languageService.getCurrentPhoneNumberLocale()}
                countries={["UA"]}
            />
            <CustomError errorKey={props.errorKey} name={props.field.toString()} />
        </div>
    );
}

export default PhoneInputComponent;
